// extracted by mini-css-extract-plugin
export default {"auditTableContainer":"auditLogs_auditTableContainer__+caGj","headerContainer":"auditLogs_headerContainer__V-E9w","header":"auditLogs_header__hxOXw"};